import { currentLocaleConfig } from '@/lib/i18n/localeSpecific';
import { cn } from '@/lib/utils';

import { Text } from '@/decodo/components/atoms/Text';
import { getWrapperMaxWidth } from '@/features/utils/utils';

type FooterProps = {
  children: React.ReactNode;
  classNames?: {
    wrapper?: string;
  };
};

export default function Footer({ classNames, children }: FooterProps) {
  const currentYear = new Date().getFullYear();

  return (
    <>
      <footer
        className={cn(
          'text-base-white bg-gray-25 dark:bg-gray-dark-950 flex justify-center py-8 md:py-20',
          classNames?.wrapper
        )}
        data-tracker-section='footer'
        data-tracker-component='footer'
      >
        <div className={cn(getWrapperMaxWidth('mid'), 'w-full px-5')}>
          {children}
        </div>
      </footer>
      <div className='dark:bg-gray-dark-900 bg-gray-50 py-3 text-center'>
        <Text
          variant='body-l'
          classNames={{
            wrapper: 'text-gray-500 dark:text-gray-dark-400',
          }}
        >
          © 2018-{currentYear} {currentLocaleConfig().footerAllRightsReserved}
        </Text>
      </div>
    </>
  );
}
